import { computed, unref } from 'vue';
import { useUpc as useUpcMCL } from '@nuxt-common/media-card-large/app/composables/useUpc';
import useTraits from '@nuxt-common/media-card-large/app/composables/useTraits';
import { useProductType } from '~/composables/useProductType';
import useConsolidatedLatchkey from '~/modules/latchkey/composables/useConsolidatedLatchkey';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import { useConsolidatedMember } from '~/composables/useConsolidatedMember';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { checkIsSiblingUpc } from '../utils/checkIsSiblingUpc';

function useUpcBase() {
  const { productId } = useProduct();
  const { isConsolidatedLatchKey, isShopTheSet } = useProductType();
  const { isTypeDrivenThirdVariantFlag: isTypeDriven, isConsolidatedThirdVariantFlag } = useProductFlags();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();

  if (isShopTheSetExpEnabled && isShopTheSet) {
    const { selectedMember } = useConsolidatedMember();
    return useUpcMCL(selectedMember);
  }

  if (isConsolidatedLatchKey) {
    return useConsolidatedLatchkey().upcData;
  }

  return useUpcMCL(productId, !isTypeDriven, isConsolidatedThirdVariantFlag);
}

export default function useUpc() {
  const { selectedUpcId, upcData, ...restOfUpcData } = useUpcBase();
  const { productId } = useProduct();
  const { isConsolidatedThirdVariantFlag } = useProductFlags();
  const { selectedSizeId, selectedColorId, selectedTypeId } = useTraits(productId);

  const selectedUpcData = computed(() => upcData.value?.upcs?.[selectedUpcId.value]);

  const isSiblingUpc = computed(() => {
    if ('isSiblingUpc' in restOfUpcData && restOfUpcData.isSiblingUpc !== undefined) {
      return Boolean(unref(restOfUpcData.isSiblingUpc));
    }

    return checkIsSiblingUpc({
      isConsolidatedThirdVariantFlag,
      selectedColorId: unref(selectedColorId),
      selectedSizeId: unref(selectedSizeId),
      selectedTypeId: unref(selectedTypeId),
      upcMap: upcData.value?.upcMap,
      selectedUpcId: selectedUpcId.value,
    });
  });

  return {
    ...restOfUpcData,
    selectedUpcId,
    upcData,

    // Todos: move this to MCL and useConsolidatedLatchkey Upc implementations
    selectedUpcData,
    isSiblingUpc,
  };
}
